import { Stack, Typography } from '@mui/material';
import { memo } from 'react';

const GmvHeader = memo(({ id }) => (
	<Stack
		spacing="4px"
		sx={{
			alignItems: 'center',
			justifyContent: 'center',
			height: '100%',
			width: '100%',
		}}
	>
		<Typography
			sx={{
				fontWeight: 500,
			}}
		>
			GMV
		</Typography>
		<Typography
			sx={{
				fontWeight: 500,
			}}
		>
			{id === 'gmv_local' ? 'Local' : 'USD'}
		</Typography>
	</Stack>
));

export default GmvHeader;
